import { render, staticRenderFns } from "./synergism.vue?vue&type=template&id=bad2588e"
import script from "./synergism.vue?vue&type=script&lang=js"
export * from "./synergism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports